export enum BorderRadius {
    small = '5px',
    medium = '10px',
    large = '20px',
    half = '50%',
}

export const colors = {
    purple: '#498999', // dark-blue
    pink: '#ffdfdf', // light-brown-2
    darkPrimary: '#fb9d9da6',
    darkPrimary2: '#ff7a7a4d',
    'alpha-White': '#ffffff65',
    'alpha-gray': '#595858d1',
    'alpha-pink': '#b9a4a3b0',
    'dark-gray': '#707070', // dark-brown
    'dark-gray-2': '#BBB1AE',
    'dark-brown': '#f76b6b',
    gray: '#7b7b7b',
    'light-gray': 'rgba(89, 88, 88, 0.3)',
    'purple-gradient':
        'linear-gradient(45deg,rgb(73 137 153) 0%,rgb(156 214 230) 100%);', // blue-gradient
    'brown-to-white-gradient':
        'linear-gradient(180deg, rgba(255,226,199,1) 0%, rgba(255,255,255,0) 55%)',
};
